export const dateTimeFormats = {
  datePicker: 'YYYY-MM-DD',
  timePicker: 'HH:mm',
  dateTimeUtc: 'YYYY-MM-DDTHH:mm:ss',
  displayDate: 'll',
  displayDateTime: 'lll'
}


/* Enums
----------------------------------- */
export const todoStatus = {
  todo: 0,
  inProgress: 1,
  done: 2
}

export const projectStatus = {
  active: 0,
  planning: 1,
  cancelled: 2,
  completed: 3
}

export const projectBookingStatus = {
  ok: 0,
  planning: 1,
  cancelled: 2
}

export const venueStatus = {
  ok: 0,
  cancelled: 1,
  notConfirmed: 2
}

export const worklogReportStatus = {
  delivered: 1,
  accepted: 2
}

export const contractStatus = {
  new: 0,
  pendingSign: 1,
  sentForSign: 2,
  signed: 3,
  cancelled: 4,
  rejected: 5
}

export const contractSignerStatus = {
  new: 0,
  sentSigning: 1,
  signed: 2,
  rejected: 3,
  expired: 4
}

export const socialMedia = {
  facebook: 0,
  instagram: 1,
  wordPress: 2
}

export const fileType = {
  document: 0,
  contract: 1,
  socialMedia: 2,
  emailAttachment: 3,
  todoAttachment: 4,
  schedule: 5
}

export const userRole = {
  admin: 'Admin',
  manager: 'Manager',
  user: 'User'
}

export const claims = {
  dashboard: 'dashboardClaim',
  project: 'projectClaim',
  member: 'memberClaim',
  budget: 'budgetClaim',
  event: 'eventClaim',
  documentDocument: 'documentDocumentClaim',
  documentContract: 'documentContractClaim',
  documentSchedule: 'documentScheduleClaim',
  hours: 'hoursClaim',
  todo: 'todoClaim',
  marketing: 'marketingClaim',
  marketingPost: 'marketingPostClaim',
  marketingSocialAccounts: 'marketingSocialAccountsClaim',
  communication: 'communicationClaim',
  contact: 'contactClaim',
  settings: 'settingsClaim',
  profile: 'profileClaim'
}

export const screen = {
  screenWidthXl: 2560
}

export const phoneType = {
  mobile: 'Mobile',
  work: 'Work',
  home: 'Home'
}

export const emailType = {
  work: 'Work',
  personal: 'Personal'
}

/* Entities schemes
----------------------------------- */
export const projectSchema = {
  titleMaxLength: 500,
  projectNumberMaxLength: 40,
  archiveNumberMaxLength: 40
}

export const contactSchema = {
  organisationNumberMaxLength: 20,
  socialSecurityNumberMaxLength: 20,
  bankAccountMaxLength: 20
}


/* Entities interfaces/defaults
----------------------------------- */
export const defaultUserState = {
  seasonId: null,
  projectId: null,
  onlyThisManager: false
}


/* WebSocket and EventLog
----------------------------------- */
export const routeNameByParam = {
  Project: 'projects',
  Member: 'members',
  Budget: 'budget',
  Event: 'events',
  Document: 'documentDocument',
  Note: 'documentNotes',
  Contract: 'documentContract',
  Schedule: 'documentSchedule',
  Todo: 'todo',
  Post: 'marketingPost',
  'Social-account': 'marketingSocialAccounts',
  Email: 'communicationEmails',
  SMS: 'communicationSms',
  Contact: 'contacts',
  User: 'settingsUsers',
  Season: 'settingsSeasons',
  ContractTemplate: 'settingsContractTemplates',
  ScheduleTemplate: 'settingsScheduleTemplates',
  BudgetCategory: 'settingsBudgetCategories',
  EventCategory: 'settingsEventCategories'
}
